import React from "react";
import "./serving-content.scss";

export type ServingContentProps = {
  children?: React.ReactNode;
};

export const ServingContent = (props: ServingContentProps) => {
  const { children } = props;
  return (
    <div className="serving__content-container">
      <h2 className="serving__content-heading">What's in a Serving</h2>
      <div className="serving__content-grid">{children}</div>
    </div>
  );
};
